// extracted by mini-css-extract-plugin
export default {"cls1":"SocialEditor-cls1__xZ","cls2":"SocialEditor-cls2_ODt SocialEditor-cls1__xZ"};